<script setup lang="ts">
import CloseableDialog from '@/src/components/CloseableDialog.vue';
import {
  cancelReplaceScan,
  confirmReplaceScan,
  onReplaceScanDialogToggle,
  replaceScanDialogOpen,
} from '@/src/io/import/replaceScanIntent';
</script>

<template>
  <closeable-dialog
    v-model="replaceScanDialogOpen"
    max-width="480"
    data-testid="replace-scan-dialog"
    @update:model-value="onReplaceScanDialogToggle"
  >
    <v-card>
      <v-card-title>Replace current scan?</v-card-title>
      <v-card-text>
        Loading a new scan will remove the current scan and any loaded meshes or
        segmentations.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="text"
          data-testid="replace-scan-cancel"
          @click="cancelReplaceScan()"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          data-testid="replace-scan-confirm"
          @click="confirmReplaceScan()"
        >
          Load new scan
        </v-btn>
      </v-card-actions>
    </v-card>
  </closeable-dialog>
</template>
